<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasExport" @click="onDownExcel">导出</el-button>

        <el-button v-if="hasAdd" type="primary" @click="$router.push('/greenEnergy/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="recordDate" label="日期">
          <el-date-picker v-model="searchForm.recordDate" placeholder="请选择日期" type="date" clearable format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="日期" prop="recordDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="光伏发电" prop="photovoltaic">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="废气" prop="exhaust">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="废气净化" prop="exhaustPurified"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="污水" prop="sewage">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="净化污水" prop="sewagePurified"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="用水" prop="waterUsage"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="用电" prop="electricityUsage"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="用天然气" prop="useNaturalGas"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="用蒸汽" prop="useSteam"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="雨水处理" prop="rainwaterTreatment"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建人姓名" prop="createUserName"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/greenEnergy/detail?energyId=' + row.energyId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/greenEnergy/edit?energyId=' + row.energyId)">编辑</el-button>

            <el-button type="text" v-if="hasDel" @click="deleteRow(row.energyId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { downloadExcelFile } from '@/utils/globalMethods'

export default {
  name: 'greenEnergy',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        recordDate: null
      }

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },

  created() {
    this.loadData()
  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.greenEnergy.selectPaGreenEnergyByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        recordDate: null
      }
      this.onSearch()
    },
    deleteRow(energyId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.greenEnergy.deleteDataPaGreenEnergy, {
          energyId
        }).then(() => {
          this.loadData()
        })
      })
    },

    onDownExcel () {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios.post(this.$apis.greenEnergy.exportPaGreenEnergy, {
        ...this.searchForm
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          downloadExcelFile(res.data, '绿色能源')
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
